exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".galaxy\\:\\:common-canvas-editor-VersionActions button[data-v-df1ab82c]{cursor:pointer;outline:none!important}.galaxy\\:\\:common-canvas-editor-VersionActions button[disabled][data-v-df1ab82c]{opacity:.65}", ""]);

